import React, { useState, useEffect } from 'react';

import logo from '../../assets/images/logo.png';

const Header = ({ openContactModal }) => {
  const [activeSection, setActiveSection] = useState('home');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'about', 'concepts', 'courses', 'testimonials', 'contact'];
      
      // Find which section is currently in view
      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          // If the section is in the viewport (with some offset to make it more intuitive)
          if (rect.top <= 150 && rect.bottom >= 150) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    // Add scroll event listener
    window.addEventListener('scroll', handleScroll);
    
    // Call once to set initial active section
    handleScroll();
    
    // Clean up
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Close mobile menu when viewport width is larger than 768px
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768 && isMobileMenuOpen) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isMobileMenuOpen]);

  // Close mobile menu when user clicks outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (isMobileMenuOpen && 
          !e.target.closest('.nav-and-cta') && 
          !e.target.closest('.mobile-menu-toggle')) {
        setIsMobileMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMobileMenuOpen]);

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobileMenuOpen]);

  const handleNavClick = (section) => {
    setActiveSection(section);
    setIsMobileMenuOpen(false);
  };

  const handleContactClick = (e) => {
    e.preventDefault();
    openContactModal();
    setIsMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="header-container">
      <div className="header-content">
        <div className="logo-container">
          <img src={logo} alt="SkillRaiz Logo" className="logo" />
        </div>
        <div className={`nav-and-cta ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
          <nav className="main-navigation">
            <ul className="nav-links">
              <li><a href="#home" className={`nav-link ${activeSection === 'home' ? 'active' : ''}`} onClick={() => handleNavClick('home')}>Home</a></li>
              <li><a href="#about" className={`nav-link ${activeSection === 'about' ? 'active' : ''}`} onClick={() => handleNavClick('about')}>About Us</a></li>
              <li><a href="#concepts" className={`nav-link ${activeSection === 'concepts' ? 'active' : ''}`} onClick={() => handleNavClick('concepts')}>Concepts</a></li>
              <li><a href="#courses" className={`nav-link ${activeSection === 'courses' ? 'active' : ''}`} onClick={() => handleNavClick('courses')}>Courses</a></li>
              <li><a href="#testimonials" className={`nav-link ${activeSection === 'testimonials' ? 'active' : ''}`} onClick={() => handleNavClick('testimonials')}>Testimonials</a></li>
              <li><a href="#contact" className={`nav-link ${activeSection === 'contact' ? 'active' : ''}`} onClick={handleContactClick}>Contact</a></li>
            </ul>
          </nav>
          <div className="cta-button-container">
            <button className="cta-button header-cta" onClick={openContactModal}>Get started now</button>
          </div>
        </div>
        <button className="mobile-menu-toggle" aria-label="Toggle Menu" onClick={toggleMobileMenu} aria-expanded={isMobileMenuOpen}>
          <span className={`menu-bar ${isMobileMenuOpen ? 'open' : ''}`}></span>
        </button>
      </div>
    </header>
  );
};

export default Header; 